import classNames from 'classnames';
import React from 'react';

import Slides from 'common/components/RewindModal/Slides';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type Top3MoviesIntroProps = {
  onNext: () => void;
  isLastStep: boolean;
  flashbackType?: number;
};

const Top3MoviesIntro: React.FC<Top3MoviesIntroProps> = ({
  onNext,
  isLastStep,
  flashbackType
}) => {
  const title = flashbackType === 6 ? 'Top 3 films Allociné' : 'Mon top films';
  const subtitle =
    flashbackType === 6
      ? "Les 3 films les mieux notés de l'année."
      : "Vos 3 films les mieux notés de l'année.";

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.startLayout)}>
        <h2 className={styles.slideTitle}>{title}</h2>
        <h3 className={styles.slideText}>{subtitle}</h3>
      </div>
      <BottomActions
        showShare={false}
        showNext={!isLastStep}
        onNextClick={onNext}
      />
    </Slides>
  );
};

export default Top3MoviesIntro;
